import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel, useTabs } from '../../../components/Tab/Tabs';
import { getCurrentYear, prepareParam } from '../../../utils/helpers';
import useRouter from 'use-react-router';
import queryString from 'query-string';
import GymStats from '../components/GymStats';
import SectionStats from '../components/SectionStats';

const TABS = {
  gyms: 0,
  sections: 1,
};

const ListView = () => {
  const { history } = useRouter();
  const searchParams = new URLSearchParams(history.location.search);
  const [pageState, setPageState] = React.useState({
    tab: searchParams.get('tab') || TABS.gyms,
    year: searchParams.get('year') || String(getCurrentYear()),
  });
  const [tab, onChangeTab] = useTabs({ tabs: TABS, defaultTab: pageState.tab });
  const topRef = React.createRef();

  const updateHistory = (searchParams) => {
    history.replace({
      search: `?${queryString.stringify(searchParams)}`,
    });
  };

  const handleChangePage = (name, value) => {
    const newState = { ...pageState, [name]: value };
    setPageState(newState);
    updateHistory(prepareParam(newState));
  };

  const onChangeYear = async (year) => {
    handleChangePage('year', year);
  };

  return (
    <Paper>
      <Tabs
        ref={topRef}
        value={tab}
        indicatorColor='primary'
        textColor='primary'
        onChange={(e, v) => onChangeTab(v)}
      >
        <Tab label={t`Зали`} />
        <Tab label={t`Види спорту`} />
      </Tabs>
      <TabPanel value={tab} index={TABS.gyms}>
        <GymStats year={pageState.year} onChangeYear={onChangeYear} />
      </TabPanel>
      <TabPanel value={tab} index={TABS.sections}>
        <SectionStats year={pageState.year} onChangeYear={onChangeYear} />
      </TabPanel>
    </Paper>
  );
};

export default ListView;
